import { render } from "./Shimmer.vue?vue&type=template&id=23bb2cd2"
import script from "./Shimmer.vue?vue&type=script&lang=js"
export * from "./Shimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__